import { useEffect, useState } from 'react'

const SCROLL_UP = 'up'
const SCROLL_DOWN = 'down'

export const useScrollDirection = ({
  initialDirection = SCROLL_UP,
  thresholdPixels,
  off,
} = {}): string => {
  const [scrollDir, setScrollDir] = useState(initialDirection)

  useEffect(() => {
    const threshold = thresholdPixels || 0
    let lastScrollY = window.pageYOffset
    let ticking = false

    const updateScrollDir = (): void => {
      const scrollY = window.scrollY
      // TODO: Fix this hack, to set page top when navigating to a new page, hard coded to navigation height
      // 62 is the height of the mobile navigation bar as specified in navigationVars.mobileHeight
      if (lastScrollY === 0 && scrollY >= 62) {
        window.scrollTo(0, 0)
      }
      if (Math.abs(scrollY - lastScrollY) < threshold) {
        // We haven't exceeded the threshold
        ticking = false
        return
      }

      setScrollDir(scrollY > lastScrollY ? SCROLL_DOWN : SCROLL_UP)
      lastScrollY = scrollY > 0 ? scrollY : 0
      ticking = false
    }

    const onScroll = (): void => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir)
        ticking = true
      }
    }

    /**
     * Bind the scroll handler if `off` is set to false.
     * If `off` is set to true reset the scroll direction.
     */
    !off
      ? window.addEventListener('scroll', onScroll)
      : setScrollDir(initialDirection)

    return (): void => window.removeEventListener('scroll', onScroll)
  }, [initialDirection, thresholdPixels, off])

  return scrollDir
}
